import api from '../api'; // از فایل api اصلی import کنید

export const productAdminApi = {

  // دریافت محصول
  get: (id) => api.get(`/products/products-admin/${id}/`),

  setActive: async (id, isActive) => {
    const response = await api.patch(`/products/products-admin/${id}/set_active/`, {
      is_active: isActive,
    });

    return response.data;
  },

  getAdminList: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/products/products-admin/?${queryString}`);
  },
  getAdminExportExcelList: (params = {}) => {
      const queryString = new URLSearchParams(params).toString();
      return api.get(`/products/products-admin/export/?${queryString}`);
    },


};

export const categoryApi = {
  // دریافت دسته‌های برگ
  getLeaves: () => api.get('/products/categories/leaves/'),

  // دریافت مشخصه‌های یک دسته
  getAttributes: (categoryId) => api.get(`/products/categories/${categoryId}/attributes/`),

  // جستجو در دسته‌ها
  search: (query) => api.get(`/products/categories/?search=${query}`),
};

